// extracted by mini-css-extract-plugin
export default {"organization_popup":"organizationAttachModal_organization_popup__uMXbM","create_item":"organizationAttachModal_create_item__i1A7M"};